import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Input,
  Box,
} from "@material-ui/core";
import {getCookie} from "components/auth/Helpers";
import moment from "moment";
import {toast} from "react-toastify";
import {Check, Close, Save} from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {pricesDataTableTheme} from "assets/css/datatable-theme.js";

const UploadExcel = ({visible, onClose}) => {
  const token = getCookie("token");
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [valuesFiltered, setValuesFiltered] = useState([]);
  const [pricesForFinance, setPricesForFinance] = useState([]);
  const [saveClicked, setSaveClicked] = useState(1);
  const [openPrices, setOpenPrices] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [pricesToUse, setPricesToUse] = useState();
  const [columnsForPrices, setColumnsForPrices] = useState(false);
  const [prices, setPrices] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const handleCloseOpenPrices = () => {
    // return console.log("props.setPricesToUse",pricesForFinance)
    setValuesFiltered([]);
    setPricesForFinance([]);
    setSaveClicked(1);
    setOpenPrices(false);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMsg("");
  };

  const handleUpload = async () => {
    if (!file) {
      setMsg("⚠️ Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/import/operations`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setExcelData(response.data);
      setMsg("✅ Upload successful");
      handleSaveForm(response.data);

      // onClose();
    } catch (err) {
      console.error(err.response);
      toast.error(err.response.data.error || "Upload failed");
      setMsg("❌ Upload failed");
    }
  };

  const handleSaveForm = async (data) => {
    console.log("data", data);

    if (saveClicked === 1) {
      data.forEach(async (record, index) => {
        let addresses = {
          initiation_address: {
            _id: record.from_location._id,
            city_id: record.from_location.location?.city_id ?? null,
            neighbourhood_id: record.from_location.location?.neighbourhood_id ?? null,
            shop_name: record.from_location.name,
            mobile: record.from_location.location?.mobile ?? null,
            code: record.from_location.code,
          },

          execution_address: {
            _id: record.to_location._id,
            city_id: record.to_location.location?.city_id ?? null,
            neighbourhood_id: record.to_location.location?.neighbourhood_id ?? null,
            shop_name: record.to_location.name,
            mobile: record.to_location.location?.mobile ?? null,
            code: record.to_location.code,
          },
        };

        if (
          record.operationType === "Preventive Maintenance" ||
          record.operationType === "Corrective Maintenance" ||
          record.operationType === "Inspection" ||
          record.operationType === "Testing"
        ) {
          // formValues[[record.cabinet.location]] = record.cabinet.location_id;
        }

        let allocationRules2 = [];

        let formValuesinString = Object.entries({
          operationType: record.operationType,
          serviceType: record.service._id,
          replacement: record.replacement ? 1 : 0,
          condition: record.cabinet.condition,
          client: record.cabinet.client,
          cabinetTypeId: record.cabinet.type,
        })
          .map(([key, value]) => {
            if (value === true) value = 1;
            if (value === false) value = 0;
            return `${key}=${value ?? ""}`;
          })
          .join("&");

        let priceRules2 = await axios(
          `${process.env.REACT_APP_BASE_URL}/priceRules/filterTop?${formValuesinString}`,
          {
            responseType: "json",
            headers: {Authorization: `Bearer ${token}`},
          },
        ).then((response) => {
          return response.data;
        });
        await axios(`${process.env.REACT_APP_BASE_URL}/allocationRules/filterTop?${formValuesinString}`, {
          responseType: "json",
          headers: {Authorization: `Bearer ${token}`},
        }).then((response) => {
          allocationRules2 = response.data;
        });
        const clientName = record.client.name;

        const cbm = record.fridgesType ? record.fridgesType.cbm : 0;
        let pricesToSave = {
          price_rule_name: priceRules2 ? priceRules2.name : "-",
          rto_fees: priceRules2 ? priceRules2.rto_fees : 0,
          branding_fees: priceRules2 ? priceRules2.branding_fees : 0,
          cabinet_testing_fees: priceRules2 ? priceRules2.cabinet_testing_fees : 0,
          corrective_reaction: priceRules2 ? priceRules2.corrective_reaction : 0,
          corrective_service_in_house: priceRules2 ? priceRules2.corrective_service_in_house : 0,
          drop: priceRules2 ? priceRules2.drop : 0,
          exchange_corrective_reaction: priceRules2 ? priceRules2.exchange_corrective_reaction : 0,
          handling_in: priceRules2 ? priceRules2.handling_in : 0,
          in_house_preventive_maintenance: priceRules2 ? priceRules2.in_house_preventive_maintenance : 0,
          min_charge: priceRules2 ? priceRules2.min_charge : 0,
          name: priceRules2 ? priceRules2.name : 0,
          preventive_maintenance: priceRules2 ? priceRules2.preventive_maintenance : 0,
          priority: priceRules2 ? priceRules2.priority : 0,
          storage: priceRules2 ? priceRules2.storage : 0,
          transp_cbm: priceRules2 ? priceRules2.transp_cbm : 0,
          transp_for_1_unit: priceRules2 ? priceRules2.transp_for_1_unit : 0,

          installation: priceRules2 ? priceRules2.installation * cbm : 0,
        };
        let transportationFeez = priceRules2 ? priceRules2.transp_for_1_unit : 0;

        setValuesFiltered((valuesFiltered) => [
          ...valuesFiltered,
          {
            line_number: index + 1,
            job_number: record.jobNumber,
            operation_number: record.operationNumber,
            operation_type: record.operationType,
            sn: record.cabinet._id,
            cabinetSn: record.cabinet.sn,
            brand: record.cabinet.brand,
            client_id: record.cabinet.client,
            client_name: clientName,
            ...addresses,
            allocation_rule: allocationRules2
              ? {
                  allocation_id: allocationRules2._id,
                  name: allocationRules2.name,
                }
              : {},
            price_rule: priceRules2
              ? {
                  price_id: priceRules2._id,
                  name: priceRules2.name,
                }
              : {},
            supplier_id: allocationRules2 ? allocationRules2.supplier_id : "",
            status: allocationRules2 ? "Assigned" : "Unassigned",
            last_status_user: "-",
            last_status_update: currentDate,
            promise_date: moment().add(priceRules2.promise_day, "days"),

            serviceType: record.service,

            with_3pl_fleet: record.with_3pl_fleet,

            replacement: record.replacement,
          },
        ]);
        setPricesForFinance((pricesForFinance) => [
          ...pricesForFinance,
          {
            validPrice: priceRules2,
            sn: record.cabinet._id,
            cabinetSn: record.cabinet.sn,
            client_id: record.cabinet.client,
            client_name: clientName,
            ...pricesToSave,
            cbm: cbm,
            transportation_fees: transportationFeez,
          },
        ]);
      });
    } else if (saveClicked === 2) {
      const fetchData = async () => {
        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/liveOperations`,
          headers: {Authorization: `Bearer ${token}`},
          data: valuesFiltered,
        })
          .then(function (response) {
            toast.success("Successfully Added", {onClose: () => handleCloseOpenPrices()});
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {});

        let locationForHistory = "";

        const statusHistoryUnassigned = valuesFiltered.map((e) => ({
          status: "Unassigned",
          user: "User 1",
          notes: "",
          sn: e.sn,
          operation_number: e.operation_number,
          location: locationForHistory,
        }));
        const statusHistoryAssigned = valuesFiltered.map((e) => {
          if (e.status === "Assigned") {
            return {
              status: "Assigned",
              supplier_id: e.supplier_id,
              user: "User 1",
              notes: "",
              sn: e.sn,
              operation_number: e.operation_number,
              location: locationForHistory,
            };
          }
        });
        // let statusHistory=[...statusHistoryAssigned,...statusHistoryUnassigned]

        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/operations/history`,
          headers: {Authorization: `Bearer ${token}`},
          data: statusHistoryUnassigned,
        });
        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/operations/history`,
          headers: {Authorization: `Bearer ${token}`},
          data: statusHistoryAssigned,
        });

        handleCloseOpenPrices();
        onClose();
      };
      fetchData();
    }
  };
  const optionsForPrices = {
    filter: false,
    selectableRows: false,
    rowsPerPage: 100,
    customFooter: () => "",
  };

  const pricesFirstRun = useRef(true);
  useEffect(() => {
    if (pricesFirstRun.current) {
      pricesFirstRun.current = false;
    } else {
      setColumnsForPrices([
        {
          name: "validPrice",
          label: "Valid Price Rule",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (tableMeta.rowData[16] === "Total") {
                return "";
              }
              return value && Object.keys(value).length ? (
                <Check className="text-success" />
              ) : (
                <Close className="text-danger" />
              );
            },
          },
        },
        {
          name: "cabinetSn",
          label: "SN",
          // options: {
          //   customBodyRender: (value, tableMeta, updateValue) => {
          //     if (value) {
          //       let snValue = excelData.filter((e) => e.cabinet._id == value);
          //       return snValue.length ? snValue[0].sn : "-";
          //     }
          //   },
          // },
        },
        {name: "price_rule_name", label: "Price Rules Name"},
        {name: "client_name", label: "Client Name"},
        {name: "handling_in", label: "Handling In"},
        {name: "storage", label: "Storage"},
        {
          name: "in_house_preventive_maintenance",
          label: "Inhouse Preventive Maintena",
        },
        {
          name: "corrective_service_in_house",
          label: "Corrective Service Inhouse",
        },
        {name: "cabinet_testing_fees", label: "Cabinet Testing Fees"},
        {name: "branding_fees", label: "Branding Fees"},
        {name: "drop", label: "drop"},
        {name: "installation", label: "Installation"},
        {name: "rto_fees", label: "RTO fees"},
        {name: "transportation_fees", label: "Transportation Fees"},
        {name: "preventive_maintenance", label: "Preventive Maintenance"},
        {
          name: "exchange_corrective_reaction",
          label: "Exchange Corrective Reaction",
        },
        {
          name: "corrective_reaction",
          label: "Corrective Reaction",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (value === "Total") return <strong>Total</strong>;
              return value;
            },
          },
        },
        {
          name: "total",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (tableMeta.rowData[15] === "Total") {
                let allNumbers = tableMeta.tableData.map((e) => e[15]).filter((e) => typeof e === "number");
                let sumOfAll = allNumbers.length ? allNumbers.reduce((a, b) => a + b) : 0;
                return sumOfAll;
              }
              return value;
            },
          },
        },
      ]);
      setOpenPrices(true);

      setPricesToUse(prices);
    }
  }, [prices]);

  const valuesFilteredFirstRun = useRef(true);
  useEffect(() => {
    if (valuesFilteredFirstRun.current) {
      valuesFilteredFirstRun.current = false;
    } else {
      if (pricesForFinance.length) {
        const fetchData = async () => {
          let pricesForFinance1 = pricesForFinance;
          if (pricesForFinance.length > 1) {
            let totalFeez = pricesForFinance.reduce((a, b) => a.transportation_fees + b.transportation_fees);
            let totalCBM = pricesForFinance.reduce((a, b) => a.cbm + b.cbm);
            let minCharge = pricesForFinance[0].min_charge;
            if (totalFeez < minCharge) {
              pricesForFinance1 = pricesForFinance.map((e) => {
                e.transportation_fees = (e.cbm * minCharge) / totalCBM;
                return e;
              });
            }
          }
          pricesForFinance1 = pricesForFinance1.map((e) => {
            return {
              validPrice: e.validPrice,
              sn: e.sn,
              cabinetSn: e.cabinetSn,
              price_rule_name: e.price_rule_name,
              client_id: e.client_id,
              client_name: e.client_name,
              branding_fees: e.branding_fees,
              rto_fees: e.rto_fees,
              cabinet_testing_fees: e.cabinet_testing_fees,
              corrective_reaction: e.corrective_reaction,
              corrective_service_in_house: e.corrective_service_in_house,
              drop: e.drop,
              exchange_corrective_reaction: e.exchange_corrective_reaction,
              handling_in: e.handling_in,
              in_house_preventive_maintenance: e.in_house_preventive_maintenance,
              name: e.name,
              preventive_maintenance: e.preventive_maintenance,
              priority: e.priority,
              storage: e.storage,
              transportation_fees: e.transportation_fees,
              installation: e.installation,
              total:
                (e.installation ?? 0) +
                (e.transportation_fees ?? 0) +
                (e.branding_fees ?? 0) +
                (e.rto_fees ?? 0) +
                (e.cabinet_testing_fees ?? 0) +
                (e.corrective_reaction ?? 0) +
                (e.corrective_service_in_house ?? 0) +
                (e.drop ?? 0) +
                (e.exchange_corrective_reaction ?? 0) +
                (e.handling_in ?? 0) +
                (e.in_house_preventive_maintenance ?? 0) +
                (e.preventive_maintenance ?? 0) +
                (e.storage ?? 0),
            };
          });
          // pricesForFinance1.push({
          //   corrective_reaction: "Total",
          // });

          setPrices(pricesForFinance1);
        };
        setSaveClicked(2);
        fetchData();
      }
    }
  }, [pricesForFinance]);

  return (
    <Dialog open={visible} onClose={onClose} maxWidth="md" fullWidth disableBackdropClick>
      <DialogTitle>Import Excel</DialogTitle>

      <Box mb={2}>
        <Button variant="outlined" color="primary" href="/operationsImportSample.xlsx" download>
          Download Excel Sample
        </Button>
      </Box>

      <DialogContent>
        <Input type="file" inputProps={{accept: ".xlsx, .xls"}} onChange={handleFileChange} />
        {msg && (
          <Typography variant="body2" style={{marginTop: 10}}>
            {msg}
          </Typography>
        )}

        {saveClicked === 2 ? (
          <Dialog maxWidth={"xl"} fullWidth open={openPrices} onClose={handleCloseOpenPrices}>
            <MuiThemeProvider theme={pricesDataTableTheme}>
              <MUIDataTable
                className="pricesDataTable"
                title="Prices"
                data={prices}
                columns={columnsForPrices}
                options={optionsForPrices}
              />
            </MuiThemeProvider>
            <div className="clientTables mx-5 my-3">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="btn btn--save"
                onClick={handleSaveForm}
                startIcon={<Save />}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                className="btn btn--save"
                onClick={handleCloseOpenPrices}
                startIcon={<Close />}
              >
                Close
              </Button>
            </div>
          </Dialog>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleUpload} color="primary" variant="contained">
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadExcel;
